import router from '@/router'

export const enum BizEntity {
  common = 'common',
  individual = 'individual',
  corporate = 'corporate'
}

interface UrlProps {
  key: BizEntity;
  stag: string;
  prod: string;
}

const urls: UrlProps[] = [
  {
    key: BizEntity.common,
    stag: 'https://sole-app.stag.overtax.co.kr/landing/select-entity',
    prod: 'https://app.sole.overtax.co.kr/landing/select-entity',
  },
  {
    key: BizEntity.individual,
    stag: 'https://sole-app.stag.overtax.co.kr/login',
    prod: 'https://app.sole.overtax.co.kr/login',
  },
  {
    key: BizEntity.corporate,
    stag: 'https://stag-app.overtax.co.kr/sign-in',
    prod: 'https://app.overtax.co.kr/sign-in',
  },
]

export const getUrl = (target: 'stag'|'prod', biz: BizEntity, searchParams: string) => {
  const selectedUrl = urls.find((item) => item.key === biz) || urls[0]
  const targetSearchParams = searchParams ? `?${searchParams}` : ''
  return `${selectedUrl[target]}${targetSearchParams}`
}

const getBizEntity = (biz: string | null) => {
  switch(biz) {
  case 'corporate':
    return BizEntity.corporate
  case 'individual':
    return BizEntity.individual
  default :
    return BizEntity.common
  }
}

const toRefund = () => {
  const params = new URLSearchParams(document.location.search);
  const bizEntityString = params.get('biz_entity')
  const target = process.env.NODE_ENV === 'production' ? 'prod' : 'stag'
  const bizEntity = getBizEntity(bizEntityString)
  if (bizEntity === BizEntity.common) {
    router.push({ name: 'select-entity', query: Object.fromEntries(params) })
  } else {
    const url = getUrl(target, bizEntity, params.toString())
    location.href = url
  }
}

export default toRefund
